// Utils
import { getSafe } from '../../utils/Object'

export default
{
    name: 'app-loader',

    props:
    {
        isActive:
        {
            type: Boolean,
            default: false
        }
    },

    data()
    {
        return {
            progress: 0
        }
    },

    computed:
    {
        content()
        {
            let content = null

            if (getSafe(() => this.$root.contentPage.loadingModal.acf))
            {
                content = this.$root.contentPage.loadingModal.acf
            }

            return content
        }
    },

    created()
    {
        this.eventHub.$on('app-loader:progress', this._onProgress)
    },

    mounted()
    {

    },

    destroyed()
    {
        this.eventHub.$off('app-loader:progress', this._onProgress)
    },

    methods:
    {
        // Events
        _onProgress(value = 0)
        {
            this.progress = value
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-loader/script.js